
import { css } from 'lit';
export default css`
/* Apply CSS Variables to the host element. */
:host{
  --sic-promo-cutout--default--content-padding:clamp(
    var(--spacing-16),
    2.857rem + 1.7857vw,
    var(--spacing-20)
  );
  --sic-promo-cutout--default--content-padding--mobile:clamp(
    var(--spacing-05),
    calc(0.5rem + 3.75vw),
    var(--spacing-08)
  );
  --sic-promo-cutout--default--left-offset:var(--spacing-16);
  --sic-promo-cutout--default--top-offset--mobile:clamp(
    var(--spacing-12),
    0.7272727272727271rem + 11.363636363636365vw,
    var(--spacing-32)
  );

  --sic-promo-cutout--default--text-size:var(--body-03-font-size);
  --sic-promo-cutout--default--text-line-height:var(--body-03-line-height);
  --sic-promo-cutout--default--text-spacing:var(--spacing-04);
  --sic-promo-cutout--default--cta-spacing:var(--spacing-08);
  --sic-promo-cutout--default--media-bg-color:var(--color-primary-lightest);
  --sic-promo-cutout--default--media-bg-blur:blur(5px);
  --sic-promo-cutout--default--border-radius:var(
    --border-radius-rounded-default
  );
}
`;